import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { FailedAlternatives } from './components/FailedAlternatives';
import { SolutionIntro } from './components/SolutionIntro';
import { AboutJose } from './components/AboutJose';
import { Services } from './components/Services';
import { BeforeAfter } from './components/BeforeAfter';
import { Gallery } from './components/Gallery';
import { VideoShowcase } from './components/VideoShowcase';
import { LifeBack } from './components/LifeBack';
import { ServiceAreas } from './components/ServiceAreas';
import { GoogleReviews } from './components/GoogleReviews';
import { Guarantee } from './components/Guarantee';
import { WhoFor } from './components/WhoFor';
import { FinalCTA } from './components/FinalCTA';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { FloatingActions } from './components/FloatingActions';
export function App() {
  return <div className="min-h-screen bg-[#F9F9F9] font-sans selection:bg-[#C8102E] selection:text-white" data-id="element-0" data-mp="3ij64a9st9l7v">
      <Navbar data-id="element-1" data-mp="3mk84asujy1aw" />
      <main data-id="element-2" data-mp="3mjq2lgp4euvl">
        <Hero data-id="element-3" data-mp="3mjgczu7zmpqf" />
        <PainSection data-id="element-4" data-mp="3rc9dg5wfbbwp" />
        <FailedAlternatives data-id="element-5" data-mp="3rbrcwx2qabiz" />
        <SolutionIntro data-id="element-6" data-mp="3rcsxpt9jqcdw" />
        <AboutJose data-id="element-7" data-mp="3reccfffk0fdk" />
        <Services data-id="element-8" data-mp="5yh2n2cyzbp" />
        <BeforeAfter data-id="element-9" data-mp="6htjo98ovic" />
        <VideoShowcase data-id="element-10" data-mp="4n5i12o8na1" />
        <Gallery data-id="element-11" data-mp="56qxrrj5tst" />
        <LifeBack data-id="element-12" data-mp="7sxpp6lk59z" />
        <ServiceAreas data-id="element-13" data-mp="2zllf11m4wkmq" />
        <GoogleReviews data-id="element-14" data-mp="2zm4wyibsb90r" />
        <Guarantee data-id="element-15" data-mp="2zmwi0z7r9ocs" />
        <WhoFor data-id="element-16" data-mp="2zng0ch1bierc" />
        <FinalCTA data-id="element-17" data-mp="33mf25srr5vek" />
        <FAQ data-id="element-18" data-mp="33lwywc6oagx5" />
      </main>
      <Footer data-id="element-19" data-mp="33n6zb810016y" />
      <FloatingActions data-id="element-20" data-mp="33myix65o2dr0" />
    </div>;
}